import React, { useState } from "react";

//MUI
import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";

import ClientArticleFormSystem from "./ClientArticleFormSystem";
import ClientArticleFormGeneral from "./ClientArticleFormGeneral";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function ClientArticleForm({
  formData,
  handleInputChange,
  payRuleOptions,
}) {
  const [tabIndex, setTabindex] = useState(0);

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabSwitch}
        sx={{ marginBottom: "2rem" }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Allmänt" />
        <Tab label="System" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <ClientArticleFormGeneral
          formData={formData}
          handleInputChange={handleInputChange}
          payRuleOptions={payRuleOptions}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <TabPanel value={tabIndex} index={1}>
          <ClientArticleFormSystem
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </TabPanel>
      </TabPanel>
    </>
  );
}
